import "./about.style.scss";

export const AboutPage = () => {
  return (
    <div className="about">
      <h1>ABOUT PAGE</h1>
      <p>This is just about blog react using react router</p>
    </div>
  );
};
